import { render, staticRenderFns } from "./DeleteDialog.vue?vue&type=template&id=ac1618d4&scoped=true&lang=pug&"
import script from "./DeleteDialog.vue?vue&type=script&lang=ts&"
export * from "./DeleteDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac1618d4",
  null
  
)

export default component.exports